// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.RentalManagerUserPropertyGetFieldsV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserPropertyGetFieldsResponseV2WebDto,
  UserPropertyGetFieldsResponseWebDto,
  UserPropertyGetFieldsV2RequestDto,
  UserPropertyGetGeneratedFieldsV2RequestDto,
} from '../..';

export const RentalManagerUserPropertyGetFieldsV2WebApiHandler_getGeneratedFields_Path =
  '/api/web/v2/users/properties/getGeneratedFields';

/**
 * Return the most recently AI-generated fields for a manual listing
 */
export const RentalManagerUserPropertyGetFieldsV2WebApiHandler_getGeneratedFields = (
  postData: UserPropertyGetGeneratedFieldsV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyGetGeneratedFieldsV2RequestDto, UserPropertyGetFieldsResponseWebDto>(
    {
      endpoint: RentalManagerUserPropertyGetFieldsV2WebApiHandler_getGeneratedFields_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyGetFieldsV2WebApiHandler_getPropertyFields_Path =
  '/api/web/v2/users/properties/getPropertyFields';

/**
 * Infer rental property listing fields for an existing manual listing
 */
export const RentalManagerUserPropertyGetFieldsV2WebApiHandler_getPropertyFields = (
  postData: UserPropertyGetFieldsV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyGetFieldsV2RequestDto, UserPropertyGetFieldsResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyGetFieldsV2WebApiHandler_getPropertyFields_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
